import { CREATE_PAYMENT_TRANSFER_RESULT_RECORD } from '../../constants/actions/payment';

export function createPaymentTransferResultRecord() {
    return {
        type: CREATE_PAYMENT_TRANSFER_RESULT_RECORD,
    };
}
